import React, { memo, useEffect } from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { isAuthenticated } from '@common/utils/authentication';
import {
  TRIAL_APP_ANDROID,
  TRIAL_APP_IOS,
  trialAppStoreUrl,
  trialNativeLaunchUrl,
} from '../../utils/trial-app-store';

export const TrialAppDownload = memo(() => {
  const { t } = useTranslation();
  const history = useHistory();
  const userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent;
  const storeUrl = trialAppStoreUrl(userAgent);
  const nativeUrl = trialNativeLaunchUrl(userAgent);

  useEffect(() => {
    if (!storeUrl) {
      if (isAuthenticated()) history.replace('/admin');
      return undefined;
    }

    // iOS custom schemes (flexappeal://) make Safari report an invalid address
    // when the app is not installed. The download buttons go to the store.
    if (/Android/i.test(userAgent) && nativeUrl) {
      window.location.replace(nativeUrl);
      return undefined;
    }

    window.location.replace(storeUrl);
    return undefined;
  }, [history, nativeUrl, storeUrl, userAgent]);

  return (
    <div className="FreeTrial__AppDownload">
      <p>{t('authentication:trial_build_download')}</p>
      <a href={TRIAL_APP_IOS}>{t('authentication:trial_build_iphone')}</a>
      <a href={TRIAL_APP_ANDROID}>{t('authentication:trial_build_android')}</a>
    </div>
  );
});

export default TrialAppDownload;
